import React, { useState } from 'react';
import { Step1 } from './step-1';
import { Step2 } from './step-2';

interface CreateDraftProps {
    onSubmit: () => void;
}

export const CreateDraft: React.FC<CreateDraftProps> = (props) => {
    const { onSubmit } = props;
    const [step1, setStep1] = useState(true);
    const [selectedOrganizationLocationId, setSelectedOrganizationLocationId] = useState(-1);

    const onNext = () => {
        setStep1(false);
    }

    const onBack = () => {
        setStep1(true);
    }

    return (
        <div style={{ minWidth: '20vw' }}>
            {step1 ? (
                <Step1
                    selectedOrganizationLocationId={selectedOrganizationLocationId}
                    setSelectedOrganizationLocationId={setSelectedOrganizationLocationId}
                    onNext={onNext}
                />
            ) : (
                <Step2
                    selectedOrganizationLocationId={selectedOrganizationLocationId}
                    onBack={onBack}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    );
};
